import { HTMLAttributes } from 'react'
import { cva, VariantProps } from 'class-variance-authority'

import Section from '@/components/base/Section'

import { cn } from '@/lib/utils'

const spacerVariants = cva(['border-0'], {
  variants: {
    variant: {
      xxs: 'h-s-spacer-xxs md:h-d-spacer-xxs',
      xs: 'h-s-spacer-xs md:h-d-spacer-xs',
      sm: 'h-s-spacer-sm md:h-d-spacer-sm',
      md: 'h-s-spacer-md md:h-d-spacer-md',
      lg: 'h-s-spacer-lg md:h-d-spacer-lg',
      xl: 'h-s-spacer-xl md:h-d-spacer-xl',
      xxl: 'h-s-spacer-2xl md:h-d-spacer-2xl'
    },
    theme: {
      transparent: 'bg-transparent'
    }
  },
  defaultVariants: {
    variant: 'md',
    theme: 'transparent'
  }
})

export type SpacerProps = HTMLAttributes<HTMLHRElement> & VariantProps<typeof spacerVariants>

const Spacer = ({ className, variant, theme = 'transparent', ...props }: SpacerProps) => {
  return (
    <Section
      asChild
      className={cn(spacerVariants({ variant, theme, className }), 'z-0, relative')}
      {...props}
    >
      <hr />
    </Section>
  )
}

export default Spacer
